const { errors } = require('@transfeeradev/api-enums');
const DictEntryDivergentDocError = require('./errors/DictEntryDivergentDocError');
const PersonTypeService = require('./PersonTypeService');

class PixDataValidationService {
  static validateDocument(dictDocument, document) {
    const dictDocumentCleared = PersonTypeService.getCpfCnpjNumber(dictDocument);
    const documentCleared = PersonTypeService.getCpfCnpjNumber(document);
    if (documentCleared && documentCleared !== dictDocumentCleared) {
      throw new DictEntryDivergentDocError(
        errors.ptBr.transferFailedReason.INFORMED_DOCUMENT_IS_DIVERGENT_FROM_ACCOUNT_OWNER.message
      );
    }
    return true;
  }
}

module.exports = PixDataValidationService;
